import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { reaction } from "mobx";
import './SequenceImageClip.styles.scss';
import {SequenceStateStore} from "../store/SequenceStateStore";
import {useAssetStore} from "../../storage/AssetStore";
import SequenceClip from "./SequenceClip";
import {ProjectAssetsStore} from "../../state/ProjectAssetsStore";

interface ImageClipProps {
    clipId: string;
    layerId: string;
}

export const SequenceImageClip: React.FC<ImageClipProps> = observer(({ clipId, layerId }) => {
    const [filename, setFilename] = useState<string | undefined>(SequenceStateStore.getClipTitle(clipId));
    const [thumbnail, setThumbnail] = useState<string | undefined>(undefined);
    const { GetThumbnailUrl } = useAssetStore();

    useEffect(() => {
        const disposer = reaction(
            () => ({ filename: SequenceStateStore.getClipTitle(clipId) }),
            ({ filename }) => setFilename(filename),
            { fireImmediately: true }
        );
        return () => disposer();
    }, [clipId]);

    useEffect(() => {
        const assetId = SequenceStateStore.clipIdToAssetId?.[clipId];
        if (!assetId) return;
        (async () => {
            try {
                const url = await GetThumbnailUrl({ thumbnailId: assetId, projectId: ProjectAssetsStore.projectId as string });
                setThumbnail(url || undefined);
            } catch {}
        })();
    }, [clipId]);

    return (
        <SequenceClip clipId={clipId} layerId={layerId} filename={filename} thumbnail={thumbnail} backgroundColor={"240, 240, 240"} />
    );
});

export default SequenceImageClip;


